// routes/index.js - Example of how to integrate protected routes
import React from "react";
import ProtectedRoute from "../components/auth/ProtectedRoute";
import FeatureGuard from "../components/auth/FeatureGuard";
import SuspensionGuard from "../components/auth/SuspensionGuard";

// Import your page components
import Home from "../pages/Home";
import JobOffersList from "../pages/JobOffers/List";
import Login from "../pages/Login";
import Register from "../pages/Register";
import ForgotPassword from "../pages/ForgotPassword";
import AboutUs from "../pages/AboutUs";
import Services from "../pages/Services";
//import PrivateRoute from "../components/PrivateRoute";
import Dashboard from "../pages/Recruiter/Dashboard";
import JobOfferDetails from "../pages/Recruiter/JobOffers/Details";
import ContactAdmin from "../pages/Contact/ContactAdmin";
import Profile from "../pages/Recruiter/Profile";
import NewOffer from "../pages/Recruiter/JobOffers/NewOffer";
import EditJobOffer from "../pages/Recruiter/JobOffers/EditOffer";
import CompanyJobOffers from "../pages/Recruiter/JobOffers/List";
import VerifyEmail from "../pages/Auth/VerifyEmail";
import CompanyMissions from "../pages/Recruiter/Missions/List";
import CreateMissionPage from "../pages/Recruiter/Missions/NewMission";
import EditMissionPage from "../pages/Recruiter/Missions/EditMission";
import MissionDetailsPage from "../pages/Recruiter/Missions/ShowMission";
import CompanyApplications from "../pages/Recruiter/Applications/List";
import RecruiterMessaging from "../pages/Recruiter/Messages/Index";
import ApplicationDetails from "../pages/Recruiter/Applications/Details";
import CalendarPage from "../pages/Recruiter/Calendar";
import CVTheque from "../pages/Recruiter/Cvtheque/List";
import Settings from "../pages/Recruiter/Settings";
import Privacy from "../pages/Privacy";
import Terms from "../pages/Terms";

const routes = [
  // Public routes
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/privacy",
    element: <Privacy />,
  },
  {
    path: "/terms",
    element: <Terms />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/register",
    element: <Register />,
  },
  {
    path: "/forgot-password",
    element: <ForgotPassword />,
  },
  {
    path: "/about",
    element: <AboutUs />,
  },
  {
    path: "/services",
    element: <Services />,
  },
  {
    path: "/job-offers",
    element: <JobOffersList />,
  },
  {
    path: "/job-offers/:id",
    element: <JobOfferDetails />,
  },
  {
    path: "/verify-email",
    element: <VerifyEmail />,
  },

  {
    path: "/contact",
    element: <ContactAdmin />,
  },


  // Protected routes - these require authentication
  // {
  //   path: "/payments",
  //   element: (
  //     <ProtectedRoute allowedRoles={["recruiter"]}>
  //       <PaymentsList />
  //     </ProtectedRoute>
  //   ),
  // },
  // {
  //   path: "/contact-admin",
  //   element: (
  //     <ProtectedRoute allowedRoles={["recruiter"]}>
  //       <ContactAdmin />
  //     </ProtectedRoute>
  //   ),
  // },

  {
    path: "/dashboard",
    element: (
      <ProtectedRoute allowedRoles={["recruiter"]}>
        <Dashboard />
      </ProtectedRoute>
    ),
  },
  {
    path: "/dashboard/messages",
    element: (
      <ProtectedRoute allowedRoles={["recruiter"]}>
        <RecruiterMessaging />
      </ProtectedRoute>
    ),
  },

  {
    path: "/dashboard/new-offer",
    element: (
      <ProtectedRoute allowedRoles={["recruiter"]}>
        <SuspensionGuard>
          <NewOffer />
        </SuspensionGuard>
      </ProtectedRoute>
    ),
  },
  {
    path: "/dashboard/job-offers",
    element: (
      <ProtectedRoute allowedRoles={["recruiter"]}>
        <SuspensionGuard>
          <CompanyJobOffers />
        </SuspensionGuard>
      </ProtectedRoute>
    ),
  },

  {
    path: "/dashboard/job-offers/:id",
    element: (
      <ProtectedRoute allowedRoles={["recruiter"]}>
        <JobOfferDetails />
      </ProtectedRoute>
    ),
  },

  {
    path: "/dashboard/missions/new-mission",
    element: (
      <ProtectedRoute allowedRoles={["recruiter"]}>
        <SuspensionGuard>
          <FeatureGuard feature="missions">
            <CreateMissionPage />
          </FeatureGuard>
        </SuspensionGuard>
      </ProtectedRoute>
    ),
  },

  {
    path: "/dashboard/cvtheque",
    element: (
      <ProtectedRoute allowedRoles={["recruiter"]}>
        <SuspensionGuard>
          <FeatureGuard feature="cvtheque">
            <CVTheque />
          </FeatureGuard>
        </SuspensionGuard>
      </ProtectedRoute>
    ),
  },



  {
    path: "/dashboard/job-offers/:id/edit",
    element: (
      <ProtectedRoute allowedRoles={["recruiter"]}>
        <SuspensionGuard>
          <EditJobOffer />
        </SuspensionGuard>
      </ProtectedRoute>
    ),
  },
  {
    path: "/dashboard/missions/edit/:id",
    element: (
      <ProtectedRoute allowedRoles={["recruiter"]}>
        <SuspensionGuard>
          <FeatureGuard feature="missions">
            <EditMissionPage />
          </FeatureGuard>
        </SuspensionGuard>
      </ProtectedRoute>
    ),
  },
  {
    path: "/dashboard/missions/:id",
    element: (
      <ProtectedRoute allowedRoles={["recruiter"]}>
        <FeatureGuard feature="missions">
          <MissionDetailsPage />
        </FeatureGuard>
      </ProtectedRoute>
    ),
  },
  {
    path: "/dashboard/missions",
    element: (
      <ProtectedRoute allowedRoles={["recruiter"]}>
        <SuspensionGuard>
          <FeatureGuard feature="missions">
            <CompanyMissions />
          </FeatureGuard>
        </SuspensionGuard>
      </ProtectedRoute>
    ),
  },

  {
    path: "/dashboard/profile",
    element: (
      <ProtectedRoute allowedRoles={["recruiter"]}>
        <Profile />
      </ProtectedRoute>
    ),
  },



  {
    path: "/dashboard/applications",
    element: (
      <ProtectedRoute allowedRoles={["recruiter"]}>
        <SuspensionGuard>
          <CompanyApplications />
        </SuspensionGuard>
      </ProtectedRoute>
    ),
  },

  {
    path: "/dashboard/applications/:type/:id",
    element: (
      <ProtectedRoute allowedRoles={["recruiter"]}>
        <SuspensionGuard>
          <ApplicationDetails />
        </SuspensionGuard>
      </ProtectedRoute>
    ),
  },

  {
    path: "/dashboard/calendar",
    element: (
      <ProtectedRoute allowedRoles={["recruiter"]}>
        <CalendarPage />
      </ProtectedRoute>
    ),
  },

  {
    path: "/dashboard/settings",
    element: (
      <ProtectedRoute allowedRoles={["recruiter"]}>
        <Settings />
      </ProtectedRoute>
    ),
  },

  // {
  //   path: '/profile',
  //   element: (
  //     <ProtectedRoute>
  //       <Profile />
  //     </ProtectedRoute>
  //   )
  // },
  // {
  //   path: '/settings',
  //   element: (
  //     <ProtectedRoute>
  //       <Settings />
  //     </ProtectedRoute>
  //   )
  // },

  // You can also create admin-only routes
  // {
  //   path: '/admin',
  //   element: (
  //     <ProtectedRoute>
  //       <AdminDashboard />
  //     </ProtectedRoute>
  //   )
  // }
];

export default routes;
